'use strict'
import {bondsReplacement} from '~/js/modules/bonds-replacement';

/* дата в формате dd.mm.yyyy */
const convertDate = (inputFormat) => {
    function pad(s) { return (s < 10) ? '0' + s : s; }
    let dat = new Date(inputFormat)
    return [pad(dat.getDate()), pad(dat.getMonth()+1), dat.getFullYear()].join('.')
}
/* склонение слов в зависимости от числа */
const createCountFormatter = ({ few, one, two }) => {
  const titles = [one, two, few]
  const cases = [2, 0, 1, 1, 1, 2]
  return function(num){
    let number = Number(num)
    let result
    if (Number.isInteger(number)) {
      number = Math.abs(number)
      result = titles[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5] ]
    } else {
      result = titles[1]
    }
    return result
  }
};

export const formatYearCount = createCountFormatter({
  few: " лет до: ",
  one: " год до: ",
  two: " года до: "
})
/* проверка на мобилу и планшет */
const mobileAndTabletCheck = () => {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check
}
/* общие функции для всего сервиса */
const commonFuncs = () => {
  /* больше-меньше фильтров */
  const bonds_filters__extend__button = document.querySelector('.js-bonds__filters-tab--more')
  const bonds_filters__extend = document.querySelectorAll('.bonds_filters__extend')

  bonds_filters__extend__button.addEventListener('click', () => {
    if (bonds_filters__extend__button.classList.contains('active')) {
      bonds_filters__extend__button.classList.remove('active')
      bonds_filters__extend__button.querySelector('span').innerText = 'Больше фильтров...'
      bonds_filters__extend.forEach((el) => {
        el.style.display = 'none'
      });
    } else {
      bonds_filters__extend__button.classList.add('active');
      bonds_filters__extend__button.querySelector('span').innerText = 'Меньше фильтров'
      bonds_filters__extend.forEach((el) => {
        if(el.querySelectorAll('.js__filter').length !== 0) {
          el.style.display = 'block'
        }
      })
    }
  })

  const dtl = document.getElementById('DataTables_Table_0_length')
  dtl.classList.add('bonds__filters-bottom')
  dtl.classList.add('wrapper-p')
}
/* округление числа */
const formatNumber = (data, fix) => {
  if (data != null) {
    return (parseFloat(data).toFixed(fix))
  } else {
    return "-"
  }
}
/* пояснения по типам купонов */
const coupon_type_text_foo = (row) => {
  let coupon_type_text = ''
  switch (row.coupon_type) {
    case '1':
      coupon_type_text = 'фиксированный'
      break;
    case '2':
      coupon_type_text = 'изменяемый'
      break;
    case '3':
      coupon_type_text = 'плавающий'
      break;
    case '4':
      coupon_type_text = 'нулевой'
      break;
    case '5':
      coupon_type_text = 'связанный с индексом'
      break;
  }
  return coupon_type_text
}

/* пояснение по гарантии */
const guarantor_type_text_foo = (row) => {
  let guarantor_type_text
  switch (row.guarantor_type) {
    case '0':
      guarantor_type_text = 'нет'
      break;
    case '1':
      guarantor_type_text = 'да/государство'
      break;
    case '2':
      guarantor_type_text = 'да/гос. агентство'
      break;
    case '3':
      guarantor_type_text = 'да/банк'
      break;
    case '4':
      guarantor_type_text = 'да/материнская компания'
      break;
    case '5':
      guarantor_type_text = 'да/материнская (субординированная гарантия)'
      break;
    default:
      guarantor_type_text = 'нет'
      break;
  }
  return guarantor_type_text;
}
/* цветная плашка про срок облигации в модальном окне */
const years_to_maturity_foo = (row) => {
  const num = parseFloat(row.years_to_maturity)
  let res = ''
  if (num < 2) {
    res = ' <span class="years_to_maturity__term is-b-green">Краткосрочная</span>'
  }
  if (num >= 2 && num < 5) {
    res = ' <span class="years_to_maturity__term is-s-blue">Среднесрочная</span>'
  }
  if (num >= 5) {
    res = ' <span class="years_to_maturity__term is-l-red">Долгосрочная</span>'
  }
  return res
}
/* раскрывание блоков фильтров */
const js__toggle = () => {
  const toggleBlocks = document.querySelectorAll('.js__toggle')
  const toggleListBlocks = document.querySelectorAll('.js__toggle-list')

  const closeOut = (item) => {
    document.addEventListener('click', (e, el) => {
      if (!item.contains(e.target)) {
        item.classList.remove('is-active')
      }
    })
  }

  if(toggleBlocks){
    toggleBlocks.forEach((el) => {
      el.querySelector('.js__toggle-btn').addEventListener('click', () => {
        el.classList.toggle('is-active')
      })
    })
  }

  if(toggleListBlocks){
    toggleListBlocks.forEach((list) => {
      const tabs = list.querySelectorAll('.js__toggle-item')
      tabs.forEach((el) => {
        el.querySelector('.js__toggle-btn').addEventListener('click', () => {
          el.classList.toggle('is-active')
          closeOut(el)
        })
        if(el.querySelectorAll('.js__filter').length === 0 && el.dataset.filter !== 'Карта рынка') {
          el.style.display = 'none'
        }
      })
    })
  }
}
/* всплывающие подсказки */
const tooltip = (text, align = '', width) => {
  let rightClass = ''
  let downClass = ''
  let minWidth = ''
  if (align=='right') {
    rightClass = 'bonds__column-tooltip_content--right'
  }
  if (align=='down') {
    downClass = 'bonds__column-tooltip_content--down'
  }
  if (width) {
    minWidth = 'style="min-width: ' + width + 'px"'
  }
    return  '<div class="bonds__column-tooltip">' +
      '  <div class="bonds__column-tooltip_content '+rightClass+' '+downClass+'" ' + minWidth +'>' + text + '</div>' +
      '   <span class="media-obj"><svg xmlns="http://www.w3.org/2000/svg">' +
      '     <use href="/assets/dist/img/sprite.svg#i-answer"></use>' +
      '     </svg>' +
      '   </span>' +
      '</div>'
}

const modeReplacementSwitcher = (rowData) => {

  const replacementModesContainerModal = document.querySelector('.js-mode-replacement-modal')
  const replacementModes = replacementModesContainerModal.querySelectorAll('input')
  if (replacementModes) {
    replacementModes.forEach((el) => {
      el.addEventListener('change', function() {
        replacementModes.forEach((el) => {
          el.parentNode.classList.remove('is-active')
        })
        this.parentNode.classList.add('is-active')
        const innerTableProcessing = document.querySelector('.bonds-replacment__container .dataTables_processing')
        if (innerTableProcessing) {
          innerTableProcessing.style.display = 'block'
        }

        bondsReplacement(rowData, this.value, false)
      })
    })
  }
}

const creditRatingTextCellStyle = (td, cellData) => {
  if ( cellData === 'AAA' || cellData === 'AA') {
    td.children[0].classList.add('is-green');
  }
  else if ( cellData === 'A' ) {
    td.children[0].classList.add('is-b-green');
  }
  else if ( cellData === 'BBB' ) {
    td.children[0].classList.add('is-l-green');
  }
  else if ( cellData === 'BB' || cellData === 'BB-' ) {
    td.children[0].classList.add('is-blue');
  }
  else if ( cellData === 'B+' || cellData === 'B' || cellData === 'B-' ) {
    td.children[0].classList.add('is-l-red');
  }
  else if ( cellData === 'CCC' || cellData === 'CC' || cellData === 'C' ) {
    td.children[0].classList.add('is-red');
    td.children[0].style.color = 'white'
  }
  else if ( cellData === 'D' ) {
    td.children[0].classList.add('is-black');
  }
  else {
    td.children[0].classList.add('is-grey');
  }
}

const qualityCellStyle = (td, cellData) => {
  if ( cellData >= 8 ) {
    td.children[0].classList.add('is-green')
  }
  else if ( cellData >= 7 && cellData < 8 ) {
    td.children[0].classList.add('is-l-green')
  }
  else if ( cellData >= 5 && cellData < 7 ) {
    td.children[0].classList.add('is-blue')
  }
  else if ( cellData >= 3 && cellData < 5 ) {
    td.children[0].classList.add('is-l-red')
  }
  else if ( cellData >= 1 && cellData < 3) {
    td.children[0].classList.add('is-red')
    td.children[0].style.color = 'white'
  }
  else if ( cellData === 0 || cellData == null) {
    $(td).find('span').text('n/a');
    td.children[0].classList.add('is-grey')
  } else {
    td.children[0].classList.add('is-red')
    td.children[0].style.color = 'white'
  }
}
const dataFilterParams = (data) => {
  /* Выбор фильтра, потому что десктопные и мобильные фильтры - это разная разметка */
  let value__i = 0
  if ( mobileAndTabletCheck() === true) {
    value__i = 1
  } else {
    value__i = 0
  }

  data.customFilters = {};
  data.customFilters.issue_date = {};
  data.customFilters.matdate = {};
  data.customFilters.bdate = {};
  data.customFilters.years_to_maturity = {};
  data.customFilters.credit_rating_text = [];
  data.customFilters.estimationRating = [];
  data.customFilters.emitent_type = [];
  data.customFilters.bond_type = [];
  data.customFilters.minlottype = [];
  data.customFilters.instrument_type = [];
  data.customFilters.frnIndex = [];
  data.customFilters.coupon_type = [];
  data.customFilters.strategy = [];
  data.customFilters.category = [];
  data.customFilters.isiis = {};
  data.customFilters.tax_free = {};
  data.customFilters.tax_currency_free = {};
  data.customFilters.tax_longterm_free = {};
  data.customFilters.rutrade = {};
  data.customFilters.new_date = {};
  data.customFilters.is_qualify = {};
  data.customFilters.is_not_qualify = {};
  data.customFilters.currencyid = [];
  data.customFilters.borrower_country = [];
  data.customFilters.sector_text = [];
  data.customFilters.industry = [];
  const customFiltersObject = [
    'quality', // Качество
    'size', // размер
    'complexity', // сложность
    'down_risk', // Рыночный риск
    'duration', // Дюрация
    'yield', // Доходность, %
    'value_of_emission', // Объем в обращении, млрд.
    'couponperiod', // Купонов в год, раз
    'last_price', // Цена, % от номинала
    'liquidity', // Ликвидность
    'vol_median', // Медиана дневного оборота
    'q_out', // Outiside Q
    'q_in', // Inside Q
    'q_balance', // Качество баланса
    'q_earnings', // Качество прибыли
    'q_ratingnetdebt_equity', // NetDebt/Equity (рейтинг)
    'q_ratingroe', // ROE (рейтинг)
    'q_col', // Изменчивость прибыли
    'not_reinvesting', // Примерная доходность, если вы не реинвестируете купоны, %
    'reinvesting', // Доля прибыли от реинвестирования по YTM
    'fact_yield', // Простая доходность, %
    'current_yield', // Текущая доходность, %
    'frnIndexAdd', // Премия/Дисконт к базовому индексу (для FRN)
  ]

  // Валюта
    const currencyElements = document.querySelectorAll('.currency__id .is-active');
      currencyElements.forEach((element) => {
        if (element.textContent.trim() !== '-') {
          data.customFilters.currencyid.push(element.textContent.trim());
        }
      });
  // Стратегия
  document.querySelectorAll('.strategy .is-active').forEach((element) => {
      const filterExport = element.getAttribute('data-filter-export');
      if (filterExport !== '-') {
        data.customFilters.strategy.push(filterExport);
      }
    });
  // кредитное качество
  document.querySelectorAll('.js-credit_rating_text .is-active').forEach((element) => {
      if (element.getAttribute('data-filter') === 'Без рейтинга') {
        data.customFilters.credit_rating_text.push('Array');
      } else {
        const filters = element.getAttribute('data-filter').split(',');
        data.customFilters.credit_rating_text.push(...filters);
      }
    });
  // Оценка облигации
  document.querySelectorAll('.js-estimationRating .is-active').forEach((element) => {
      const filters = element.getAttribute('data-filter').split(',');
      data.customFilters.estimationRating.push(...filters);
    });
  // Отрасли
  document.querySelectorAll('.js-industry .is-active').forEach((element) => {
      data.customFilters.industry.push(...element.getAttribute('data-filter').split(','));
    });
  // Тип купона  РУСЛАН, посмотри, пожалуйста, так работает, а через document.querySelectorAll не работает, задача WEB-5681 была
  // Вернул пока в такое состояние, чтоб работало, это у тебя менялось в коммите от 11 июня, он там один
  $.each($('.coupon_type .is-active'), function(){
    data.customFilters.coupon_type.push($(this).attr('data-filter-export'));
  });
  // страна заёмщика
  document.querySelectorAll('.borrower_country .is-active').forEach((element) => {
      data.customFilters.borrower_country.push(element.textContent.trim());
    });
  // Отрасль
  document.querySelectorAll('.sector_text .is-active').forEach((element) => {
      data.customFilters.sector_text.push(element.textContent.trim());
    });
  // тип эмитента
  document.querySelectorAll('.emitent_type .is-active').forEach((element) => {
      data.customFilters.emitent_type.push(element.getAttribute('data-filter-export'));
    });
  // Тип инструмента
  document.querySelectorAll('.instrument_type .is-active').forEach((element) => {
      data.customFilters.instrument_type.push(element.getAttribute('data-filter-export'));
    });
  // Привязка к индексу
  document.querySelectorAll('.frnIndex .is-active').forEach((element) => {
      data.customFilters.frnIndex.push(element.getAttribute('data-filter-export'));
    });
  // Тип облигации
  document.querySelectorAll('.bond_type .is-active').forEach((element) => {
      data.customFilters.bond_type.push(element.getAttribute('data-filter-export'));
    });
  // Доступно для ИИС
  const isActiveIsiisGeneral = document.querySelector('.isiis_general')?.classList.contains('is-active');
  const isActiveIsiis = document.querySelector('.isiis')?.classList.contains('is-active');
  data.customFilters.isiis = (isActiveIsiisGeneral || isActiveIsiis) ? '1' : '0';
  // Купоны без НДФЛ
  const taxFreeElement = document.querySelector('.tax_free');
  data.customFilters.tax_free = taxFreeElement?.classList.contains('is-active') ? '1' : '0';
  // Валютная переоценка без НДФЛ
  const taxCurrencyFreeElement = document.querySelector('.tax_currency_free');
  data.customFilters.tax_currency_free = taxCurrencyFreeElement?.classList.contains('is-active') ? '1' : '0';
  // Льгота по времени владения
  const taxLongTermFreeElement = document.querySelector('.tax_longterm_free');
  data.customFilters.tax_longterm_free = taxLongTermFreeElement?.classList.contains('is-active') ? '1' : '0';
  // доступные в России
  const rutradeElement = document.querySelector('.rutrade');
  data.customFilters.rutrade = rutradeElement?.classList.contains('is-active') ? '1' : '0';
  // Новые выпуски
  const newDateGenElement = document.querySelector('.js-new_date_gen');
  data.customFilters.new_date = newDateGenElement?.classList.contains('is-active') ? '1' : '0';
  // Минимальный лот
  document.querySelectorAll('.minlottype .is-active').forEach((element) => {
      data.customFilters.minlottype.push(element.getAttribute('data-filter-export'));
    });
  // Для квал. инвесторов
  const isQualifyActive = document.querySelector('.is_qualify')?.classList.contains('is-active');
  data.customFilters.is_qualify = isQualifyActive ? '1' : '0';

  const isNotQualifyActive = document.querySelector('.is_not_qualify')?.classList.contains('is-active');
  data.customFilters.is_not_qualify = isNotQualifyActive ? '1' : '0';

  customFiltersObject.forEach((param) => {
    data.customFilters[param] = {}
    let from = document.querySelectorAll(`.${param}_from`)
    let to = document.querySelectorAll(`.${param}_to`)
    if (from.length > 0 && to.length > 0) {
      if (from[value__i]) {
        data.customFilters[param].from = parseFloat(from[value__i].value)
      }
      if (to[value__i]) {
        data.customFilters[param].to = parseFloat(to[value__i].value)
      }
    }
  })
  // Дата выпуска
  let idf = document.querySelectorAll('.issue_date_from')[value__i].value;
  (idf!='') ? data.customFilters.issue_date.from = idf : data.customFilters.issue_date.from = "0000-00-00";
  let idt = document.querySelectorAll('.issue_date_to')[value__i].value;
  (idt!='') ? data.customFilters.issue_date.to = idt : data.customFilters.issue_date.to = "3000-01-01";
  // Дата погашения
  let mf = document.querySelectorAll('.matdate_from')[value__i].value;
  (mf!='') ? data.customFilters.matdate.from = mf : data.customFilters.matdate.from = "0000-00-00";
  let mt = document.querySelectorAll('.matdate_to')[value__i].value;
  (mt!='') ? data.customFilters.matdate.to = mt : data.customFilters.matdate.to = "3000-01-01";
  // Дата оферты
  let bf = document.querySelectorAll('.bdate_from')[value__i].value;
  (bf!='') ? data.customFilters.bdate.from = bf : data.customFilters.bdate.from = "0000-00-00";
  let bt = document.querySelectorAll('.bdate_to')[value__i].value;
  (bt!='') ? data.customFilters.bdate.to = bt : data.customFilters.bdate.to = "3000-01-01";
  // Срок до погашения/ выкупа, лет
  // Краткосрочные
  let mst = document.querySelectorAll('.js-years_to_maturity_short_term')[value__i].classList.contains('is-active')
  // Среднесрочные
  let mmt = document.querySelectorAll('.js-years_to_maturity_middle_term')[value__i].classList.contains('is-active')
  // Долгосрочные
  let mlt = document.querySelectorAll('.js-years_to_maturity_long_term')[value__i].classList.contains('is-active')
  if (mst) { data.customFilters.years_to_maturity.short = 1 }
  if (mmt) { data.customFilters.years_to_maturity.middle = 1 }
  if (mlt) { data.customFilters.years_to_maturity.long = 1 }
  const ytm_from = document.querySelectorAll('.years_to_maturity_from')
  const ytm_to = document.querySelectorAll('.years_to_maturity_to')
  if (!mst && !mmt && !mlt && ytm_from.length > 0 && ytm_to.length > 0) {
    data.customFilters.years_to_maturity.from = parseFloat(ytm_from[value__i].value);
    data.customFilters.years_to_maturity.to = parseFloat(ytm_to[value__i].value);
  }
  // Только ликвидные
  const liquidityElement = document.querySelector('.liquidity');
  data.customFilters.liquidity.only = liquidityElement?.classList.contains('is-active') ? '1' : '0';
  // Поиск
  data.customFilters.search_string = document.querySelector('.js__filter-input').value

  return data;

}

/* подсказки для оценки облигаций */
const estimate_rating = (row) => {
  let row_rating = ''
  const rating = row.estimationRating
  switch (rating) {
    case '5':
      row_rating += '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">' +
              '<path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>' +
            '</svg> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">' +
              '<path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>' +
            '</svg> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">' +
              '<path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>' +
            '</svg> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">' +
              '<path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>' +
            '</svg> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">' +
              '<path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>' +
            '</svg> ' + tooltip('Недооценена, доходность выше аналогов (лучше аналогов)','down',12)
      break;
    case '4':
      row_rating += '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">' +
              '<path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>' +
            '</svg> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">' +
              '<path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>' +
            '</svg> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">' +
              '<path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>' +
            '</svg> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">' +
              '<path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>' +
            '</svg> ' + tooltip('Справедливая цена, доходность умеренно выше аналогов','down',12)
      break;
    case '3':
      row_rating += '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">' +
              '<path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>' +
            '</svg> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">' +
              '<path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>' +
            '</svg> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">' +
              '<path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>' +
            '</svg> ' + tooltip('Справедливая цена, доходность умеренно ниже аналогов','down',12)
      break;
    case '2':
      row_rating += '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">' +
              '<path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>' +
            '</svg> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">' +
              '<path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>' +
            '</svg> ' + tooltip('Странная недооценка, доходность необычно выше аналогов','down',12)
      break;
    case '1':
      row_rating += '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">' +
              '<path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>' +
            '</svg> ' + tooltip('Переоценена, доходность ниже аналогов (хуже аналогов)','down',12)
      break;
    case '0':
      row_rating += '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-half" viewBox="0 0 16 16">' +
              '<path d="M5.354 5.119 7.538.792A.52.52 0 0 1 8 .5c.183 0 .366.097.465.292l2.184 4.327 4.898.696A.54.54 0 0 1 16 6.32a.55.55 0 0 1-.17.445l-3.523 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256a.5.5 0 0 1-.146.05c-.342.06-.668-.254-.6-.642l.83-4.73L.173 6.765a.55.55 0 0 1-.172-.403.6.6 0 0 1 .085-.302.51.51 0 0 1 .37-.245zM8 12.027a.5.5 0 0 1 .232.056l3.686 1.894-.694-3.957a.56.56 0 0 1 .162-.505l2.907-2.77-4.052-.576a.53.53 0 0 1-.393-.288L8.001 2.223 8 2.226z"/>' +
            '</svg> ' + tooltip('Странная переоценка, доходность необычно ниже аналогов','down',12)
      break;
    case '-1':
      row_rating += 'Аномалия ' + tooltip('Очень большое отклонение доходности от аналогов (выброс)','down',12)
      break;
    default:
      row_rating += 'n/a ' + tooltip('Оценка доходности невозможна из-за отсутствия или недостатка данных','down',12)
      break;
  }

  return row_rating
}

/* всплывающие подсказки */
const spec_tooltip = (text, align = '') => {
  let rightClass = ''
  let downClass = ''
  if (align==='right') {
    rightClass = 'bonds_special-tooltip_content--right'
  }
  if (align==='down') {
    downClass = 'bonds_special-tooltip_content--down'
  }
  return  '<div class="bonds_special-tooltip">' +
    '  <div class="bonds_special-tooltip_content '+rightClass+' '+downClass+'">' + text + '</div>' +
    '</div>'
}

/* индикаторы особенностей в таблице */
const spec_indicator = (row) => {
  let special_info = ''
  if (row.eventFlag) {
    const events = row.eventFlag.split(',')
    events.forEach((ev) => {
      switch (ev) {
        case 'ONTRADE':
          // special_info += ' <div class="bonds_special is-l-green1">' + spec_tooltip('Эта облигация находится в обращении (дата погашения не наступила)','down') + '</div>'
          // не отображать
          break;
        case 'REDEEMED':
          // special_info += ' <div class="bonds_special is-vd-grey1">' + spec_tooltip('Эта облигация уже погасилась','down') + '</div>'
          // не отображать
          break;
        case 'MATDATE':
          // special_info += ' <div class="bonds_special is-red1">' + spec_tooltip('По этой облигации наступила дата погашения и ожидается платеж (grace period). Обычно платеж поступает в течение 1-5 торговых дней. Если платеж от эмитента не поступит в течение 10 дней, то статус облигации изменится на "дефолт"  (если иное не установлено решением о выпуске)','down') + '</div>'
          // не отображать
          break;
        case 'NOPAID':
          // special_info += ' <div class="bonds_special is-red1">' + spec_tooltip('По этой облигации наступила дата погашения, но платеж от эмитента не поступил в течение 10 дней. При этом дефолт не объявлен. Возможно решением о выпуске установлен более длинный период, в которой эмитент может погасить облигацию без объявления дефолта','down') + '</div>'
          // не отображать
          break;
        case 'DEFAULT':
          // special_info += ' <div class="bonds_special is-red1">' + spec_tooltip('По этой облигации допущен дефолт','down') + '</div>'
          // не отображать
          break;
        case 'SIMPLE':
          special_info += ' <div class="bonds_special is-l-green1">' + spec_tooltip('Это самая простая облигация (все купоны известны и фиксированы до даты погашения облигации, бумага погашается по номиналу)','down') + '</div>'
          break;
        case 'AMO':
          special_info += ' <div class="bonds_special is-vd-grey1">' + spec_tooltip('Амортизируемые облигации (часть номинальной стоимости выплачивается до даты погашения облигаций)','down') + '</div>'
          break;
        case 'PUT':
          special_info += ' <div class="bonds_special is-l-orange">' + spec_tooltip('Возможность выкупа облигаций по требованию владельцев до конца срока погашения облигаций (как правило, это означает, что размер купонов известен только до какой-то даты, а потом может измениться. Поэтому может потребоваться ваше внимание и участие в предъявлении облигации к выкупу)','down') + '</div>'
          break;
        case 'CALL':
          special_info += ' <div class="bonds_special is-l-orange">' + spec_tooltip('Возможность выкупа облигаций по требованию эмитента до даты погашения облигаций','down') + '</div>'
          break;
        case 'FNOM':
          special_info += ' <div class="bonds_special is-l-orange">' + spec_tooltip('Облигация с индексируемым номиналом (например, облигации привязанные к инфляции). Если вы держите такие облигации не до погашения, то результат инвестирования остается неопределенным относительно индекса, к которому привязаны такие бумаги','down') + '</div>'
          break;
        case 'DSC':
          special_info += ' <div class="bonds_special is-vd-grey1">' + spec_tooltip('Дисконтные облигации (доход образуется при погашении за счет дисконта к номиналу, купоны не выплачиваются)','down') + '</div>'
          break;
        case 'FLT':
          special_info += ' <div class="bonds_special is-l-orange">' + spec_tooltip('Плавающий купон (ставка и/или размер купона могут изменяться в зависимости от определенной формулы или индекса)','down') + '</div>'
          break;
        case 'PERP':
          special_info += ' <div class="bonds_special is-red1">' + spec_tooltip('Вечная облигация (имеет очень высокий риск изменения цены в следствии изменении процентных ставок)','down') + '</div>'
          break;
        case 'SUB':
          special_info += ' <div class="bonds_special is-red1">' + spec_tooltip('Это более рискованные облигации, чем все остальные. При определенных условиях эмитент может не платить по ним купоны или списать их номинал без банкротства','down') + '</div>'
          break;
        case 'WRN':
          special_info += ' <div class="bonds_special is-red1">' + spec_tooltip('Структурный продукт или иная очень сложная облигация','down') + '</div>'
          break;
        case 'CON':
          special_info += ' <div class="bonds_special is-red1">' + spec_tooltip('Конвертируемые облигации (при определенных условиях могут конвертироваться в акции или другие облигации)','down') + '</div>'
          break;
        case 'PROF':
          special_info += ' <div class="bonds_special is-orange">' + spec_tooltip('Облигация, предназначения для квалифицированных инвесторов. Это означает, что в нее заложены сложные правила, она предоставляет меньше прав инвесторам или несет большие риски','down') + '</div>'
          break;
        case 'GUR':
          special_info += ' <div class="bonds_special is-l-green1">' + spec_tooltip('Есть гарантия. Выполнение обязательств эмитента гарантированно государством, гос. агентством, банком или материнской компанией','down') + '</div>'
          break;
        case 'PLD':
          special_info += ' <div class="bonds_special is-l-scarlet">' + spec_tooltip('С залоговым обеспечением. Это может быть ипотека, автокредиты и пр. Такие облигации могут обладать скрытыми особенностями, которые могут сделать облигацию относительно сложной и непредсказуемой. Например, номинал может неожиданно частично или полностью погашаться, могут быть скрытые возможности досрочного выкупа облигаций или сложная методика определения размера купона','down') + '</div>'
          break;
        default:
          special_info += ''
          break;
      }
    })
  }

  return special_info
}
/* расчёт перцентиля */
const percentile = (arr, n) => {
  const k = (arr.length-1) * n
  const f = Math.floor(k)
  const c = Math.ceil(k)
  if (f===c) {
    return arr[k]
  }
  const d0 = arr[f] * (c-k)
  const d1 = arr[c] * (k-f)
  return d0+d1
}

const percentileSLiderUpdate = (value, obj) => {
  const values = Object.values(obj);
  let bestScoreValues = []
  values.forEach(value => {
    if (value['best_score'] && value['best_score'] !== '-1' ) {
      bestScoreValues.push(value['best_score'])
    }
  })
  bestScoreValues.sort()

  let percentileValue = percentile(bestScoreValues, value)
  let percentileBestScoreValues = []
  bestScoreValues.forEach(v => {
    if (v >= percentileValue) {
      percentileBestScoreValues.push(v)
    }
  })

  let uniqueBestScoreChars = [...new Set(percentileBestScoreValues)]

  return uniqueBestScoreChars
}


export { commonFuncs, convertDate, formatNumber, coupon_type_text_foo,
          js__toggle, mobileAndTabletCheck,
            creditRatingTextCellStyle,
         qualityCellStyle, modeReplacementSwitcher, percentile, percentileSLiderUpdate,
         dataFilterParams, tooltip, spec_indicator, estimate_rating }
